
<template>
  <div class="header" >
      <div class="iconfont" style="margin-right:0.2rem" @click="goBack()">&#xe666;</div>
      <div>{{title}}</div>
  </div>
</template>


<script>
export default {
  name: "mm-header",
  props: ["title"],
  data() {
    return {};
  },
  watch: {},

  created() {},

  methods: {
    goBack() {
      this.$router.push("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
  /* 86 52 138 */

  font-size: 0.52rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #32374e;
  line-height: 1.38rem;
  height: 1.38rem;
  letter-spacing: 1px;
  padding: 0 0.3rem;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: start;
  align-items: center;
  box-sizing: border-box;
  background:#fff
}
.title {
  padding-top: 0.8rem;
  padding-left: 0.4rem;
  font-size: 0.46rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #1a1a1a;
  line-height: 0.52rem;
  /* letter-spacing: 1px; */
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue